import Head from "next/head";
// import { productCarouselSchema } from "../src/constants/carouselSchema";
// import {
//   mahindraImagePacks,
//   piaggioImagePacks,
// } from "../src/constants/imagePacks";
// import { peopleAlsoAskSchema } from "../src/constants/peopleAlsoAskSchema";
// import {
//   mahindraPrdouctSchema,
//   piaggioPrdouctSchema,
// } from "../src/constants/productSchema";

import {
  // articleSchema,
  searchWebSite,
  webPageSpeakable,
  organizationSchema,
} from "../src/constants/structuredFAQ";
// import { localBusinessSchema } from "../src/constants/localBusinessSchema";
import { MemoizedHome } from "../src/pages/Home";
import dynamic from "next/dynamic";
import {
  TITLE,
  META_CONTENT,
  HOME_LINK,
  CONNECT_HEADING,
  CONNECT_SUBHEADING,
  CONNECT_CTA_TEXT,
} from "../src/constants/homePage/index.js";

const MemoizedCityPopupLazy = dynamic(
  () => import("../src/Popups/cityPopup/cityPopup").then((mod) => mod.MemoizedCityPopup),
  { ssr: false }
)

const BookVehicleDrawerLazy = dynamic(
  () => import("../src/modules/Home/Drawer/bookVehicleDrawer"),
  { ssr: false }
)

const CarouselDrawerLazy = dynamic(
  () => import("../src/modules/Home/Drawer/carouselDrawer"),
  { ssr: false }
)

const FullscreenDrawerLazy = dynamic(
  () => import("../src/modules/Home/HomePageRevamp/VehicleSlideDrawer"),
  { ssr: false }
)

const LoanFormPopupLazy = dynamic(
  () => import("../src/Drawer/LoanFormPopupV2"),
  { ssr: false }
)

const MemoizedFooterLazy = dynamic(
  () => import("../src/layouts/footer").then((mod) => mod.MemoizedFooter),
  { ssr: false }
)

const MemoizedConnectDrawerLazy = dynamic(
  () => import("../src/Drawer/connectDrawer").then((mod) => mod.MemoizedConnectDrawer),
  { ssr: false }
)

export default function Home() {
  return (
    <>
      <Head>
        <title>{TITLE}</title>
        <link rel="preload" href={`${process.env.NEXT_PUBLIC_CDN_LINK}HomePageV2/homePageBannerNew.webp`} as="image" fetchPriority= "high" />
        {META_CONTENT.map((meta, index) => (
          <meta
            key={index}
            {...(meta.name ? { name: meta.name } : { property: meta.property })}
            content={meta.content}
          />
        ))}
        {/* Google store verification meta information */}
        <meta name="google-site-verification" content="Z4WHXzpop_N_b6hE5g7A0fCENRwj5VqC3nSEsXLaQ3Y" />

        <link rel="canonical" href={HOME_LINK} />

        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(peopleAlsoAskSchema),
          }}
        /> */}

        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
        /> */}

        {/* WebPage Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSpeakable) }}
        />

        {/* LocalBusiness Schema */}
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
        /> */}

        {/* WebSite Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(searchWebSite) }}
        />

        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(piaggioPrdouctSchema),
          }}
        /> */}

        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(mahindraPrdouctSchema),
          }}
        /> */}

        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(piaggioImagePacks),
          }}
        /> */}

        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(mahindraImagePacks),
          }}
        /> */}

        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productCarouselSchema),
          }}
        /> */}

        {/* Organization Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(organizationSchema),
          }}
        />
      </Head>

      <MemoizedHome />
      {/* <QlDrawerComponent /> */}

      <MemoizedCityPopupLazy />
      <BookVehicleDrawerLazy />
      <CarouselDrawerLazy />
      <FullscreenDrawerLazy />

      <MemoizedConnectDrawerLazy
        heading={CONNECT_HEADING}
        subHeading={CONNECT_SUBHEADING}
        ctaText={CONNECT_CTA_TEXT}
      />

      {/* V2_State_Test */}
      {/* <LoanFormPopup /> */}

      <LoanFormPopupLazy />
      <MemoizedFooterLazy />
    </>
  );
}
